import { useEffect, useRef, useState } from "react";

export function useLayoutShift() {
   const ref = useRef();
   const [state, setState] = useState({
      shifted: false,
      overflowX: false,
   });

   useEffect(() => {
      if (!ref.current) return;

      const el = ref.current;

      let prevLeft = el.getBoundingClientRect().left;

      const check = () => {
         const rect = el.getBoundingClientRect();
         const shifted = rect.left !== prevLeft;
         const overflowX = el.scrollWidth > el.clientWidth;

         if (shifted || overflowX !== state.overflowX) {
            setState({ shifted, overflowX });
         }

         prevLeft = rect.left;
      }

      const resizeObserver = new ResizeObserver(check);
      resizeObserver.observe(el);

      window.addEventListener('resize', check);
      window.addEventListener('scroll', check);

      return () => {
         resizeObserver.disconnect();
         window.removeEventListener('resize', check);
         window.removeEventListener('scroll', check);
      }

   }, [ref]);

   return { ref, state };
}